import { Button, Group, Stack, Text } from '@mantine/core';
import { Modal } from 'src/design-system/Modal';

import type { ArenaRun } from '../hooks/useModelArena';
import { runMoment } from '../runGrouping';
import { timeLabel } from '../runLabels';

/** Deleting a run removes it from W&B, which is where a finished run lives — so it is gone for
 * everyone, not just here. Worth saying out loud before it happens. */
export function DeleteRunModal({
  run,
  opened,
  onClose,
  onConfirm,
}: {
  run: ArenaRun;
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal opened={opened} onClose={onClose} title="Delete this run?">
      <Stack gap="sm">
        <Text size="sm">
          This removes the run from Weights &amp; Biases, where its record lives — the leaderboard
          and every breakdown go with it, for everyone. It cannot be undone.
        </Text>
        <Text size="xs" c="dimmed">
          {timeLabel(runMoment(run))} · {run.candidates.join(', ')}
        </Text>
        <Group justify="flex-end" gap="xs">
          <Button variant="subtle" onClick={onClose}>
            Keep it
          </Button>
          <Button color="red" onClick={onConfirm}>
            Delete for everyone
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
